import {
  FleetAssetsTypes,
  InitialAppStateTypes,
} from '../../types/reducerTypes';

export const getFleetData = (state: InitialAppStateTypes): FleetAssetsTypes =>
  state.fleet;
